/** How often the page checks whether it was suspended. */
const CHECK_INTERVAL_MS = 5_000
/** How late a check must run to mean the device slept or the page was frozen, not that the page was busy. */
const SUSPENDED_MS = 10_000

/**
 * Calls `onWake` when the page runs again after the device slept or the browser
 * froze the page. No browser event reports this, and timers may not count the
 * suspended time, so connections can look open until their own timeouts fire.
 * A periodic check that runs long after the wall clock expected it is the
 * portable sign. Returns the function that stops watching.
 */
export function watchSystemWake(onWake: () => void) {
  let last = Date.now()
  const timer = setInterval(() => {
    const now = Date.now()
    const late = now - last - CHECK_INTERVAL_MS
    last = now
    if (late >= SUSPENDED_MS) onWake()
  }, CHECK_INTERVAL_MS)
  return () => clearInterval(timer)
}
